export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Mining Engineer | London',
    'I finally understand the complete picture of the critical minerals industry—from geology through mining, extraction, refining, battery materials, and global supply chains. This resource transformed how I approach projects professionally.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Metallurgical Professional | Dublin',
    'I know exactly how to explain lithium deposits, extraction technologies, chemical processing, battery materials, and project economics. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Critical Minerals Specialist | Amsterdam',
    'The technical depth saves me countless hours. The integrated case studies are organized step-by-step. I never struggle with technical explanations anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Mining Professional',
    "Lithium geology and extraction technologies completely changed how I understand mining projects. It's the clearest technical resource I've found.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Mineral Processing Specialist',
    'The technical glossary and extraction comparison guide alone are worth the price. I never struggle with technical terminology or technology decisions anymore. Everything is organized and accessible.',
  ],
  [
    'MS',
    'Martin S.',
    'Project Development Engineer',
    'The 12 industry scenarios and global supply chain atlas were eye-opening. I can now explain lithium deposits, mining methods, chemical refining, battery materials, and project economics across hard-rock, brine, and DLE contexts. This transformed my professional credibility.',
  ],
];
